module.exports = __webpack_public_path__ + "static/media/web03_ch02.73bbbed5.png";